// S1000D Capability options extracted from SNS standard
export const CAPABILITY_OPTIONS = [
  "00 - Product - General",
  "04 - Worthiness (fit for purpose) limitations",
  "05 - Scheduled/unscheduled maintenance",
  "06 - Dimensions and areas",
  "07 - Lifting, shoring, recovering and transporting",
  "08 - Leveling and weighing",
  "09 - Handling and maneuvering",
  "10 - Parking, mooring, storing and return to service",
  "11 - Placards and markings",
  "12 - Servicing",
  "14 - Product loading and offloading",
  "15 - Crew information",
  "16 - Change of role",
  "18 - Vibration and noise analysis and attenuation",
  "20 - Standard practices - Airframe systems",
  "21 - Environmental control",
  "22 - Auto flight",
  "23 - Communications",
  "24 - Electrical power",
  "25 - Equipment/Furnishings",
  "26 - Fire protection",
  "27 - Flight controls",
  "28 - Fuel",
  "29 - Hydraulic power",
  "30 - Ice and rain protection",
  "31 - Data acquisition",
  "33 - Lights",
  "34 - Navigation",
  "35 - Oxygen",
  "36 - Pneumatic",
  "37 - Vacuum",
  "38 - Water/Waste",
  "39 - Attack system management",
  "40 - Operational attack functions",
  "41 - Water ballast",
  "42 - Cross-technical attack functions",
  "43 - Tactical communications",
  "44 - Cabin systems",
  "45 - Central maintenance system (CMS)",
  "46 - Systems integration and display",
  "47 - Liquid nitrogen",
  "48 - In-flight refueling tanker",
  "49 - Airborne auxiliary power",
  "50 - Cargo and accessory compartment",
  "51 - Standard practices - Structures",
  "52 - Doors",
  "53 - Fuselage",
  "54 - Nacelles/pylons",
  "55 - Stabilizers",
  "56 - Windows and canopies",
  "57 - Wings",
  "58 - Armament and payload",
  "60 - Standard practices - Propeller/Rotor",
  "61 - Propellers/Propulsors",
  "62 - Main rotors",
  "63 - Main rotor drives",
  "64 - Tail rotor",
  "65 - Tail rotor drive",
  "66 - Folding blades/Pylon",
  "67 - Rotors flight control",
  "68 - Integrated flight and propulsion controls",
  "70 - Standard practices - Engine",
  "71 - Power plant",
  "72 - Engine",
  "73 - Engine fuel and control",
  "74 - Ignition",
  "75 - Air",
  "76 - Engine controls",
  "77 - Engine indicating",
  "78 - Exhaust",
  "79 - Oil",
  "80 - Starting",
  "81 - Turbines",
  "82 - Water injection",
  "83 - Accessory gearboxes",
  "84 - Propulsion augmentation",
  "85 - Fuel cell system",
  "86 - Lift system",
  "87 - Propulsion battery",
  "90 - Recovery",
  "91 - Air vehicle wiring",
  "92 - Radar",
  "93 - Surveillance",
  "94 - Weapons system",
  "95 - Crew escape and safety",
  "96 - Missiles, drones and telemetry",
  "97 - Image recording",
  "98 - Meteorological and atmospheric research",
  "99 - Electronic warfare",
  "A0 - Propulsion",
  "A1 - Power pack",
  "A2 - Power unit",
  "A3 - Engine cooling system",
  "A4 - Fuel systems",
  "A5 - Air and exhaust systems",
  "A6 - Lubrication systems",
  "A7 - Transmission",
  "A8 - Automotive/remote piloting and digital control systems",
  "A9 - Controls (drivers)",
  "B0 - Structure",
  "B1 - Hull/frame",
  "B2 - Body/Cab",
  "B3 - Suspension/track/wheels",
  "B4 - Turret assembly",
  "B5 - Structures and buildings",
  "B6 - Sites",
  "B7 - Masts",
  "B8 - Containers",
  "C0 - Armaments",
  "C1 - Gun systems",
  "C2 - Guided missile systems",
  "C3 - Rocket systems and pyrotechnics",
  "C4 - Aircraft related weapon systems",
  "C5 - Fire control systems",
  "C6 - Torpedo systems",
  "C7 - Electronic warfare",
  "D0 - Electrical system",
  "D1 - Electrical systems (engine/power pack)",
  "D2 - Electrical systems (hull/frame)",
  "D3 - Electrical systems (body/cab)",
  "D4 - Electrical systems (turret)",
  "D5 - Power Supply",
  "D6 - Electrical power emergency supplies",
  "D7 - Electrical control systems",
  "D8 - Batteries",
  "E0 - Communications",
  "E1 - Communication systems",
  "E2 - Identification friend/foe (IFF)",
  "E3 - Antennas",
  "E4 - Tempest",
  "F0 - Navigation",
  "F1 - Navigation systems",
  "F2 - Dependent",
  "F3 - Computing",
  "G0 - Surveillance",
  "G1 - Surveillance systems",
  "G2 - Meteorological/atmospheric research",
  "G3 - Sonar",
  "G4 - Electromagnetic",
  "G5 - Optical",
  "G6 - Digital",
  "G7 - Identification systems",
  "H0 - Steering",
  "H1 - Steering systems and control",
  "H2 - Thrusters",
  "H3 - Stabilizing systems and control",
  "H4 - Diving control systems",
  "H5 - Hydroplanes",
  "J0 - Ventilation/Heating/Cooling",
  "J1 - Ventilation/heating/cooling systems",
  "K0 - Hydraulic system",
  "K1 - Main hydraulic power systems",
  "K2 - Auxiliary hydraulics power systems",
  "K3 - Pneumatic system",
  "L0 - Electronic system",
  "L1 - Electronics",
  "M0 - Auxiliary",
  "M1 - Aircraft handling systems",
  "M2 - Sea water systems",
  "M3 - Fresh water systems",
  "M4 - Fuels and lubricants systems",
  "M5 - Gas systems",
  "M6 - Cargo handling replenishment systems",
  "M7 - Machinery",
  "M8 - Deck machinery",
  "N0 - Survivability",
  "N1 - Damage control",
  "N2 - Escape facilities",
  "N3 - Firefighting systems",
  "N4 - Nuclear, biological, chemical",
  "N5 - Salvage systems",
  "N6 - Stability",
  "P0 - Special equipment/system",
  "P1 - Special to type equipment",
  "P2 - Special recovery equipment",
  "P3 - Special fit equipment",
  "P4 - Special purpose equipment",
  "Q0 - Outfit and furnishings",
  "Q1 - Stowage",
  "Q2 - Complete equipment schedule (CES)",
  "R0 - Training",
  "R1 - Training services",
  "S0 - Repair test and support",
  "S1 - Power pack repair facility (PPRF)",
  "S2 - Sighting systems repair facility",
  "S3 - Thermal imaging repair facility",
  "S4 - General-purpose electronic repair facility",
  "S5 - Common support equipment",
  "T0 - Management system",
  "T1 - Platform management system",
  "T3 - Combat management and data transfer system",
  "U0 - Meteorological and oceanography systems",
  "U1 - Meteorological systems",
  "U2 - Oceanography systems",
  "U3 - Data transmission",
  "U4 - Data processing",
  "U5 - Man-Machine Interfaces",
  "U6 - Data receivers"
];

export const S1000D_VERSIONS = [
  "Issue 4.0",
  "Issue 4.1",
  "Issue 4.2",
  "Issue 5.0",
  "Issue 6.0"
];

export const SECURITY_CLASSIFICATIONS = [
  "01 - Unclassified",
  "01 - Official (AU)",
  "02 - Restricted",
  "02 - Official Sensitive (AU)",
  "03 - Confidential",
  "03 - Protected (AU)",
  "04 - Secret",
  "05 - Top Secret"
];
